import React from "react";
import phoneNumberIllustrationLogo from "./PhoneNumberIllustrationLogo.svg";

function PhoneNumberIllustrationLogoIcon({
  alt = "Phone number illustration",
  className = "",
  height = 191,
  width = 190,
}) {
  return (
    <img
      alt={alt}
      className={className}
      height={height}
      src={phoneNumberIllustrationLogo}
      width={width}
    />
  );
}

export default PhoneNumberIllustrationLogoIcon;
